<template>
    <div class="elder-healthy">
        <mt-header fixed title="健康信息编辑">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <mt-field label="血压" placeholder="收缩压/舒张压 mmHg" v-model="blood_pressure"></mt-field>
            <mt-field label="血糖" placeholder="毫摩尔/升" v-model="blood_candy"></mt-field>

            <mt-checklist title="病史" v-model="disease_history" :options="diseaseHistoryOptions"></mt-checklist>

            <mt-field label="遗传病史" placeholder="请输入遗传病史" type="textarea" rows="4" v-model="genetic_disease"></mt-field>
            <mt-field label="既往病史" placeholder="请输入既往病史" type="textarea" rows="4" v-model="old_disease"></mt-field>

            <mt-checklist title="药物过敏史" v-model="allergic" :options="allergicOptions"></mt-checklist>
            <mt-checklist title="家族病史" v-model="family_disease" :options="familyDiseaseOptions"></mt-checklist>
            <mt-checklist title="慢性病" v-model="slow_disease" :options="slowDiseaseOptions"></mt-checklist>

            <mt-radio title="健康状况自评" v-model="healthy_estimate" :options="healthyEstimateOptions"></mt-radio>
            <mt-radio title="自理能力自评" v-model="self_care_estimate" :options="selfCareEstimateOptions"></mt-radio>

            <mt-checklist title="身体状况" v-model="body_situation" :options="bodySituationOptions"></mt-checklist>
            <mt-checklist title="心理特征" v-model="mind_special" :options="mindSpecialOptions"></mt-checklist>
            <mt-checklist title="痴呆前兆" v-model="ad_symptom" :options="adSymptomOptions"></mt-checklist>
            <mt-checklist title="现存症状" v-model="body_symptom" :options="bodySymptomOptions"></mt-checklist>

            <mt-radio title="饮食习惯" v-model="diet" :options="dietOptions"></mt-radio>
            <mt-radio title="饮酒情况" v-model="drunk" :options="drunkOptions"></mt-radio>
            <mt-radio title="日抽烟情况" v-model="smoke" :options="smokeOptions"></mt-radio>
            <mt-radio title="日睡眠情况" v-model="sleep" :options="sleepOptions"></mt-radio>
            <mt-checklist title="体育锻炼" v-model="exercise" :options="exerciseOptions"></mt-checklist>

            <mt-radio title="是否长期用药" v-model="is_using_medicine" :options="isUsingMedicineOptions"></mt-radio>


            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>

    export default{


        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,

                blood_pressure:'',
                blood_candy:'',
                genetic_disease:'',
                old_disease:'',

                allergic:[],
                allergicOptions:[],

                disease_history:[],
                diseaseHistoryOptions:[],

                family_disease:[],
                familyDiseaseOptions:[],

                slow_disease:[],
                slowDiseaseOptions:[],

                healthy_estimate:'',
                healthyEstimateOptions:[],

                self_care_estimate:'',
                selfCareEstimateOptions:[],

                body_situation:[],
                bodySituationOptions:[],

                mind_special:[],
                mindSpecialOptions:[],

                ad_symptom:[],
                adSymptomOptions:[],

                body_symptom:[],
                bodySymptomOptions:[],

                diet:'',
                dietOptions:[],

                drunk:'',
                drunkOptions:[],

                smoke:'',
                smokeOptions:[],

                sleep:'',
                sleepOptions:[],

                exercise:[],
                exerciseOptions:[],

                is_using_medicine:'0',
                isUsingMedicineOptions:[
                    {
                        label:'否',value:'0'
                    },{
                        label:'是',value:'1'
                    }
                ]

            }
        },

        methods:{
            //mini-select
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateElder(){

                this.$indicator.open('加载中');

                this.$axios.post("/elder/healthy", {openid:this.openid,elder:this.id,blood_pressure:this.blood_pressure,blood_candy:this.blood_candy,genetic_disease:this.genetic_disease,old_disease:this.old_disease,allergic:this.allergic,disease_history:this.disease_history,family_disease:this.family_disease,slow_disease:this.slow_disease,healthy_estimate:this.healthy_estimate,self_care_estimate:this.self_care_estimate,body_situation:this.body_situation,mind_special:this.mind_special,ad_symptom:this.ad_symptom,body_symptom:this.body_symptom,diet:this.diet,drunk:this.drunk,smoke:this.smoke,sleep:this.sleep,is_using_medicine:this.is_using_medicine,exercise:this.exercise})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {

                            this.$toast('修改成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        },

        created(){
            this.$axios.get('/elder/healthy?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        var allergic_array = Array();
                        for(let i=0;i<data.data.options.allergic.length;i++){
                            allergic_array[i] = { label:data.data.options.allergic[i],value:data.data.options.allergic[i]};
                        }
                        this.allergicOptions = allergic_array;

                        var disease_history_array = Array();
                        for(let i=0;i<data.data.options.disease_history.length;i++){
                            disease_history_array[i] = { label:data.data.options.disease_history[i],value:data.data.options.disease_history[i]};
                        }
                        this.diseaseHistoryOptions = disease_history_array;

                        var family_disease_array = Array();
                        for(let i=0;i<data.data.options.family_disease.length;i++){
                            family_disease_array[i] = { label:data.data.options.family_disease[i],value:data.data.options.family_disease[i]};
                        }
                        this.familyDiseaseOptions = family_disease_array;

                        var slow_disease_array = Array();
                        for(let i=0;i<data.data.options.slow_disease.length;i++){
                            slow_disease_array[i] = { label:data.data.options.slow_disease[i],value:data.data.options.slow_disease[i]};
                        }
                        this.slowDiseaseOptions = slow_disease_array;

                        var healthy_estimate_array = Array();
                        for(let i=0;i<data.data.options.healthy_estimate.length;i++){
                            healthy_estimate_array[i] = { label:data.data.options.healthy_estimate[i],value:data.data.options.healthy_estimate[i]};
                        }
                        this.healthyEstimateOptions = healthy_estimate_array;

                        var self_care_estimate_array = Array();
                        for(let i=0;i<data.data.options.self_care_estimate.length;i++){
                            self_care_estimate_array[i] = { label:data.data.options.self_care_estimate[i],value:data.data.options.self_care_estimate[i]};
                        }
                        this.selfCareEstimateOptions = self_care_estimate_array;

                        var body_situation_array = Array();
                        for(let i=0;i<data.data.options.body_situation.length;i++){
                            body_situation_array[i] = { label:data.data.options.body_situation[i],value:data.data.options.body_situation[i]};
                        }
                        this.bodySituationOptions = body_situation_array;

                        var mind_special_array = Array();
                        for(let i=0;i<data.data.options.mind_special.length;i++){
                            mind_special_array[i] = { label:data.data.options.mind_special[i],value:data.data.options.mind_special[i]};
                        }
                        this.mindSpecialOptions = mind_special_array;

                        var ad_symptom_array = Array();
                        for(let i=0;i<data.data.options.ad_symptom.length;i++){
                            ad_symptom_array[i] = { label:data.data.options.ad_symptom[i],value:data.data.options.ad_symptom[i]};
                        }
                        this.adSymptomOptions = ad_symptom_array;

                        var body_symptom_array = Array();
                        for(let i=0;i<data.data.options.body_symptom.length;i++){
                            body_symptom_array[i] = { label:data.data.options.body_symptom[i],value:data.data.options.body_symptom[i]};
                        }
                        this.bodySymptomOptions = body_symptom_array;

                        var diet_array = Array();
                        for(let i=0;i<data.data.options.diet.length;i++){
                            diet_array[i] = { label:data.data.options.diet[i],value:data.data.options.diet[i]};
                        }
                        this.dietOptions = diet_array;

                        var drunk_array = Array();
                        for(let i=0;i<data.data.options.drunk.length;i++){
                            drunk_array[i] = { label:data.data.options.drunk[i],value:data.data.options.drunk[i]};
                        }
                        this.drunkOptions = drunk_array;

                        var smoke_array = Array();
                        for(let i=0;i<data.data.options.smoke.length;i++){
                            smoke_array[i] = { label:data.data.options.smoke[i],value:data.data.options.smoke[i]};
                        }
                        this.smokeOptions = smoke_array;

                        var sleep_array = Array();
                        for(let i=0;i<data.data.options.sleep.length;i++){
                            sleep_array[i] = { label:data.data.options.sleep[i],value:data.data.options.sleep[i]};
                        }
                        this.sleepOptions = sleep_array;

                        var exercise_array = Array();
                        for(let i=0;i<data.data.options.exercise.length;i++){
                            exercise_array[i] = { label:data.data.options.exercise[i],value:data.data.options.exercise[i]};
                        }
                        this.exerciseOptions = exercise_array;


                        let healthy_info = data.data.data;
                        if(healthy_info!==null){
                            this.blood_pressure = healthy_info.blood_pressure;
                            this.blood_candy = healthy_info.blood_candy;
                            this.genetic_disease = healthy_info.genetic_disease;
                            this.old_disease = healthy_info.old_disease;
                            this.healthy_estimate = healthy_info.healthy_estimate;
                            this.self_care_estimate = healthy_info.self_care_estimate;
                            this.diet = healthy_info.diet;
                            this.drunk = healthy_info.drunk;
                            this.smoke = healthy_info.smoke;
                            this.sleep = healthy_info.sleep;
                            this.is_using_medicine = healthy_info.is_using_medicine.toString();

                            this.allergic = healthy_info.allergic===null?[]:healthy_info.allergic.split(',');
                            this.disease_history = healthy_info.disease_history===null?[]:healthy_info.disease_history.split(',');
                            this.family_disease = healthy_info.family_disease===null?[]:healthy_info.family_disease.split(',');
                            this.slow_disease = healthy_info.slow_disease===null?[]:healthy_info.slow_disease.split(',');
                            this.body_situation = healthy_info.body_situation===null?[]:healthy_info.body_situation.split(',');
                            this.mind_special = healthy_info.mind_special===null?[]:healthy_info.mind_special.split(',');
                            this.ad_symptom = healthy_info.ad_symptom===null?[]:healthy_info.ad_symptom.split(',');
                            this.body_symptom = healthy_info.body_symptom===null?[]:healthy_info.body_symptom.split(',');
                            this.exercise = healthy_info.exercise===null?[]:healthy_info.exercise.split(',');
                        }


                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }



    }
</script>



// WEBPACK FOOTER //
// src/pages/elder/healthy.vue